import React from 'react'
import SupplyBillItemsAllFilterAgreeNachSupply from './fields/SupplyBillItemsAllFilterAgreeNachSupply'
import SupplyBillItemsAllFilterAgreeEconomist from './fields/SupplyBillItemsAllFilterAgreeEconomist'
import SupplyBillItemsAllFilterAgreeDeputyDirectorSupply from './fields/SupplyBillItemsAllFilterAgreeDeputyDirectorSupply'
import SupplyBillItemsAllFilterAgreeHeader from './fields/SupplyBillItemsAllFilterAgreeHeader'
import SupplyBillItemsAllFilterStatus from './fields/SupplyBillItemsAllFilterStatus'

const SupplyBillItemsAllFilters = () => {
  return (
    <div className='myBlock__filtersOptions'>
		{/* <SupplyBillItemsAllFilterStatus /> */}
		<SupplyBillItemsAllFilterAgreeNachSupply />
		<SupplyBillItemsAllFilterAgreeEconomist />
		<SupplyBillItemsAllFilterAgreeDeputyDirectorSupply />
		<SupplyBillItemsAllFilterAgreeHeader />
        {/* <SupplyOrdersFilterStatus />
        <SupplyOrdersFilterDepartment /> */}
    </div>
  )
}

export default SupplyBillItemsAllFilters